// Operational lot links open the seller's submissions search, not the public auction page.
export const catawikiLotUrl = (number) => /^\d+$/.test(String(number || "")) ? `https://www.catawiki.com/en/v/lots/submissions?q=${number}` : null;

export function catawikiStockUrl(lot) {
  const query = new URLSearchParams({ search: lot.stage === "restocked" ? lot.item?.item_id || "" : lot.catawiki_lot_number || lot.item?.item_id || "" });
  if (["sold", "shipped"].includes(lot.stage)) query.set("tab", "sold");
  else if (lot.stage === "restocked") query.set("tab", "restocked");
  else if (lot.stage) query.set("stage", lot.stage);
  return `/catawiki/submitted?${query}`;
}

export function jewelryStatusLabel(item) {
  if (item.not_found) return "Not found";
  if (item.status === "MOVED") return "Moved";
  if (item.status === "on_memo") return item.sales_agent ? `With agent · ${item.sales_agent.name}` : "On memo";
  if (item.status === "returned_to_supplier") return "Returned to supplier";
  if (item.status === "deleted") return "Deleted";
  if (item.status === "dissolved") return "Dissolved set";
  if (![undefined, null, "", "in_stock", "in_set", "sold", "at_auction"].includes(item.status)) return "Status review";
  if (item.catawiki_stage === "review") return "Needs review";
  if (["cancelled", "unsold"].includes(item.catawiki_stage)) return "Return review";
  if (item.catawiki_stage === "shipped") return "Sold · shipped";
  if (item.catawiki_stage === "sold") return "Sold · Catawiki";
  if (item.status === "sold") return "Sold";
  if (item.catawiki_stage || item.status === "at_auction") return "At auction";
  if (item.status === "in_set") return "In set";
  return "In stock";
}

export function jewelryStatusColor(item) {
  const label = jewelryStatusLabel(item);
  if (label === "In stock") return "#34D399";
  if (label === "On memo" || label.startsWith("With agent ·")) return "#A78BFA";
  if (label.startsWith("Sold")) return "#D4AF37";
  if (["Returned to supplier", "Moved", "Deleted", "Dissolved set"].includes(label)) return "#94A3B8";
  return "#F59E0B";
}
